exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:1088px){.header-navigation[data-v-6c628305]{display:flex;justify-content:space-between;min-height:63px;max-height:63px;background-color:hsla(0,0%,100%,.9);border-bottom:2px solid #f5f5f5}.header-navigation .nav-item[data-v-6c628305]{display:flex;min-width:36px}.header-navigation .nav-item[data-v-6c628305]:first-child{margin-left:15px;max-width:36px}.header-navigation .nav-item[data-v-6c628305]:last-child{margin-right:15px;max-width:36px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c628305","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/AppHeader/AppHeaderNavigation.vue
// module id = LGp5
// module chunks = 18